import React, { useRef, useState } from 'react';
import { PlayIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function Videos() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <section className="w-full bg-rosa-50 py-12 sm:py-20" aria-labelledby="videos-titulo" data-id="element-230" data-mp="10k7hh415v45a">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-231" data-mp="vq3bamzpz059">
        <Reveal className="text-center" data-id="element-232" data-mp="qrjmmetqra97">
          <p className="font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-frambuesa sm:text-xs" data-id="element-233" data-mp="qskwifz0tqpc">
            Videos explicativos
          </p>
          <h2 id="videos-titulo" className="mt-3 font-serif text-2xl leading-tight text-borgona sm:text-4xl" data-id="element-234" data-mp="hrwihl9mnqcg">
            Mirá el proceso en video y aprendé a tu ritmo
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-suave sm:text-lg" data-id="element-235" data-mp="1wb84tbrn72nl">
            Videos explicativos donde ves cada técnica en detalle. Pausá, repetí
            y practicá cuando tengas un rato.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-10 flex justify-center" data-id="element-236" data-mp="1n86zhdalpfkz">
          {/* Marco de celular */}
          <div className="relative mx-auto w-full max-w-[280px] overflow-hidden rounded-[2.5rem] border-[8px] border-white bg-black shadow-xl sm:max-w-[320px]" data-id="element-237" data-mp="1s7a6v4e1zxw4">
            {/* Muesca (Notch) */}
            <div className="absolute left-1/2 top-0 z-20 h-6 w-32 -translate-x-1/2 rounded-b-3xl bg-white" aria-hidden="true" data-id="element-238" data-mp="2jyg9brh8y7ok" />
            
            <div className="relative aspect-[9/16] w-full" data-id="element-239" data-mp="2azcooj2flk7y">
              <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/mTKaqkJiwDRpqEHQgqZqPp/IMG_2745.MOV" className="h-full w-full object-cover" playsInline loop onClick={togglePlay} data-id="element-240" data-mp="2b1yw8ipbnzq6" />
              
              {!isPlaying && <button type="button" onClick={togglePlay} className="absolute inset-0 flex items-center justify-center bg-black/20 transition-colors hover:bg-black/30" aria-label="Reproducir video" data-id="element-241" data-mp="ficsetua7tvx">
                  <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/90 text-frambuesa shadow-lg backdrop-blur-sm transition-transform hover:scale-105 sm:h-20 sm:w-20" data-id="element-242" data-mp="6q13xdiqagil">
                    <PlayIcon className="ml-1 h-8 w-8 fill-frambuesa" aria-hidden="true" data-id="element-243" data-mp="3sx9503mm818t" />
                  </span>
                </button>}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}